import { LocaleUtil } from "@utils/locale.util";

const initBrevo = (lang: string) => {
  window.Argoli.Brevo.updateLanguage(
    LocaleUtil.getRootLanguageCodeFromLocaleString(lang),
  );
};

export default initBrevo;
